<div class="popup-overlay" *ngIf="popupSetting.show"></div>
<div *ngIf="popupSetting.show" class="popup-wrapper img-upload-popup">
  <div *ngIf="errorMessages.length > 0" class="popup-error-wrapper">
    <div class="popup-error-message custom-scrollbar" *ngFor="let message of errorMessages">
      {{ message }}
    </div>
  </div>
  <div class="popup-header">
    <img src="/assets/images/icon-thumbnail.svg" alt="thumb" class="img-fluid" />
    <h6 class="typog-h6 font-weight-bold mb-0">Upload your Icons</h6>
    <span class="typog-lg">These will be available to use in your widget’s property panels.</span>
  </div>
  <div class="popup-body">
    <div class="input-wrap" finxoneWorkflowFrontendImageUploadDirective (fileDropped)="onFileDropped($event)">
      <input
        type="file"
        #fileDropRef
        id="fileDropRef"
        [accept]="imageAcceptanceType"
        (change)="fileBrowseHandler($event)"
      />
      <h3>
        Drag and drop file here or
        <label for="fileDropRef">Choose file</label> to upload
      </h3>
      <span>2 MB Max Size </span>
    </div>

    <hr class="mt-6" />

    <div>
      <div class="text-center">
        <h6 class="typog-h6 font-weight-bold mb-0">Your Icon Library</h6>
        <span class="typog-lg">Note the colours of personal icons will be fixed.</span>
      </div>
      <div *ngIf="projectIconsService.projectIconsList?.length" class="d-flex justify-content-flex-start my-3" (scroll)="onScroll($event)">
        <div
          *ngFor="let icon of projectIconsService.projectIconsList"
          [class.selectedImage]="icon.isActive"
          [class.disabled-image]="icon.isDisabled"
        >
          <div class="logo-img m-1">
            <img src="{{ icon.path }}" width="26" title="{{ icon.iconNamespace }}:{{ icon.iconName }}" />
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="files?.length" class="files-list-wrapper custom-scrollbar">
      <div class="file" *ngFor="let file of files; index as idx">
        <div class="icon">
          <img src="/assets/images/image-file-thumbnail.svg" alt="thumb" class="img-fluid" />
        </div>
        <div class="file-details">
          <div class="file-name" [ngClass]="file?.hasSizeError ? 'error' : ''">
            <h3>{{ file.name }}</h3>
            <span class="progress" *ngIf="!file?.hasSizeError && !processingImages">
              {{ uploadProgress !== 100 ? uploadProgress + '%' : 'Complete' }}
            </span>
            <span class="progress" *ngIf="processingImages">
              <img src="/assets/images/loading-icon.svg" alt="loading" />&nbsp;Processing
            </span>
            <span class="progress" *ngIf="file?.hasSizeError && !processingImages">Failed</span>
          </div>
          <div class="progress d-flex">
            <progress id="file" [value]="uploadProgress" max="100"></progress>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="popup-footer">
    <button (click)="closePopup('cancel')">Close</button>
<!--    <button class="positive" (click)="closePopup('done')">Save</button>-->
  </div>
</div>
